import {absCenter, font_s_sm} from '@xpertdox_js/xdstyle';
import {colors} from '../defaultSettings';

const menuItemCommon = {
  marginTop: '35px',
  padding: 0,
  width: '100px',
  left: '-35px',
  top: 0,
  height: '30px',
  position: 'relative',
  background: colors.bg.toolbarItem,
  color: colors.toolbarItemText,
  borderRight: colors.bg.toolbarItem === 'none' ? 'none' : '1px solid ' + colors.headerMenuBorderDrk,
  zIndex: 20,
  backfaceVisibility: 'hidden',
}


export default {
  container: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    background: colors.bg.sidebar,
    zIndex: 20,
    overflowX: 'hidden'
  },
  menuItem: menuItemCommon,
  menuItemHov: {
    background: colors.bg.toolbarItemHov,
    boxShadow: '1px 0px 2px rgba(0,0,0,0.08)',
  },
  menuItemText: {
    ...absCenter,
    ...font_s_sm,
    zIndex: 20
  },
  menuItemActivated: {
    ...menuItemCommon,
    background: colors.bg.toolbarItemAct,
    color: colors.highlight,
    boxShadow: 'inset 0 -1px 3px ' + colors.opacShadeLt,
  }
}
